import { toBlob } from "html-to-image";

// Snapshots a DOM node to a PNG Blob. Aimed at the boss matrix `<table>` node
// (not its scroll wrapper) so the full-width matrix is captured regardless of
// what is scrolled into view. html-to-image re-renders via SVG foreignObject,
// which handles the app's Tailwind v4 `oklch` colors (html2canvas cannot).
export async function captureElementPng(node: HTMLElement): Promise<Blob> {
  // Resolve the current theme's background to an rgb() string so transparent
  // gaps between raid groups render on the right surface in both themes.
  const backgroundColor = getComputedStyle(document.body).backgroundColor;

  // Fonts must be loaded, or text measures with fallback metrics and wraps differently.
  await document.fonts.ready;

  // html-to-image lays text out a hair narrower than the live DOM, wrapping
  // tight labels (stand-in badge, footer rule warnings) that fit on screen.
  // `data-capturing` flips those to nowrap for the capture only — see styles.css.
  node.setAttribute("data-capturing", "");
  try {
    const blob = await toBlob(node, { pixelRatio: 2, backgroundColor });
    if (!blob) throw new Error("Kunde inte skapa en bild av setupen.");
    return blob;
  } finally {
    node.removeAttribute("data-capturing");
  }
}
